import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Camera, Save, Loader2 } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
export function ProfileSection() {
  const {
    user
  } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || ''
  });
  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsEditing(false);
    }, 1500);
  };
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6" data-id="element-2154">
      <div className="flex justify-between items-center mb-6" data-id="element-2155">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-2156">
          Profile Information
        </h3>
        {!isEditing ? <button onClick={() => setIsEditing(true)} className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-2157">
            Edit Profile
          </button> : <div className="flex space-x-3" data-id="element-2158">
            <button onClick={() => setIsEditing(false)} className="text-sm text-gray-500 hover:text-gray-700 font-medium" data-id="element-2159">
              Cancel
            </button>
            <button onClick={handleSave} disabled={isLoading} className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50" data-id="element-2160">
              {isLoading ? <Loader2 className="h-3 w-3 animate-spin mr-1" data-id="element-2161" /> : <Save className="h-3 w-3 mr-1" data-id="element-2162" />}
              Save
            </button>
          </div>}
      </div>

      <div className="flex flex-col sm:flex-row items-start gap-6" data-id="element-2163">
        <div className="relative group" data-id="element-2164">
          <div className="h-24 w-24 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 text-3xl font-bold border-4 border-white shadow-sm" data-id="element-2165">
            {user?.name.charAt(0)}
          </div>
          {isEditing && <button className="absolute bottom-0 right-0 p-1.5 bg-white rounded-full shadow-md border border-gray-200 text-gray-500 hover:text-blue-600" data-id="element-2166">
              <Camera className="h-4 w-4" data-id="element-2167" />
            </button>}
        </div>

        <div className="flex-1 w-full grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-2168">
          <div data-id="element-2169">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2170">
              Full Name
            </label>
            <input type="text" disabled={!isEditing} value={formData.name} onChange={e => setFormData({
            ...formData,
            name: e.target.value
          })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-50 disabled:text-gray-500" data-id="element-2171" />
          </div>
          <div data-id="element-2172">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2173">
              Email Address
            </label>
            <input type="email" disabled={!isEditing} value={formData.email} onChange={e => setFormData({
            ...formData,
            email: e.target.value
          })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-50 disabled:text-gray-500" data-id="element-2174" />
          </div>
          <div data-id="element-2175">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2176">
              Phone Number
            </label>
            <input type="tel" disabled={!isEditing} value={formData.phone} onChange={e => setFormData({
            ...formData,
            phone: e.target.value
          })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-50 disabled:text-gray-500" data-id="element-2177" />
          </div>
          <div data-id="element-2178">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2179">
              Role
            </label>
            <input type="text" disabled value={user?.role} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-50 text-gray-500 sm:text-sm capitalize" data-id="element-2180" />
          </div>
        </div>
      </div>
    </div>;
}